import { createStandardAction } from 'typesafe-actions';
import { IVideoTextState } from './types';

const setVideoText = createStandardAction('VIDEO_TEXT/SET')<IVideoTextState>();

export { setVideoText };
